import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Form from 'components/Form';
import Message from 'components/Message';
import MiddlePanel from './MiddlePanel';
import HeaderPanel from './HeaderPanel';
import inputs from './form.json';
import { signUp } from 'redux/actions';
import Spinner from 'components/Spinner';

const RegisterPanel = () => {
    const dispatch = useDispatch();
    const { loading, register, error } = useSelector((state) => state.sign);
    const handleSaveUserData = (data) => {
        dispatch(signUp(data));
    };

    return (
        <Fragment>
            <Form
                className="form-outline sign--form"
                type="register"
                inputs={inputs.register}
                errorFields={error && error.fields}
                data={register || []}
                handleSubmitEv={handleSaveUserData}
                // handleInputEv={handleInputChange}
                submitTitle="Zarejestruj"
                formMessage={<Message position="register" />}
                formHeader={<HeaderPanel>Załóż konto w Garneczki</HeaderPanel>}
                formMiddle={
                    <MiddlePanel>
                        Rejestrując się, akceptujesz{' '}
                        <a target="_blank" href=" https://garneczki.pl/regulamin">
                            Regulamin i Politykę Prywatności
                        </a>{' '}
                        Garneczki.pl
                    </MiddlePanel>
                }
            />
            {loading && <Spinner position="absolute" bg="white" />}
        </Fragment>
    );
};

export default RegisterPanel;
